<style lang="sass">
@import ~bi/utilities
@import ~bi/brand/variables
@import ./src/assets/sass/m3_variables
@import ./src/assets/sass/m3_forms
</style>

<template>
    <div class="g_field g_placeholder" :class="['g_' + (data.id), {g_required: data.required, g_visually_hidden: captcha, g_small: small, g_alternate: col, g_number: (data.type == 'number'), g_nomargin: nomargin}]">
        <input
            v-bind:value="value"
            v-on:input="$emit('input', $event.target.value)"
            :id="data.id"
            :name="data.id"
            :type="data.type"
            :inputmode="data.inputmode"
            :min="data.min"
            :class="{g_error: data.error, g_format: data.format, g_filled: value !== '', g_changed: value !== data.oldvalue, g_sublabel: data.sublabel }" />
        <label :for="data.id">
            <span v-html="data.label" />
            <small v-if="data.sublabel" class="g_sublabel" v-html="data.sublabel" />
        </label>
        <span v-html="data.error" class="g_error" />
        <span v-if="data.format !== ''" v-html="data.format" class="g_format" />
    </div>
</template>

<script>
import Vue from 'vue'
import Resource from 'vue-resource'
Vue.use(Resource)

export default {
    name: 'textfield',
    props: {
        value: {
            type: String,
            default: ''
        },
        data: {
            type: Object,
            required: true
        },
        hidden: {
            type: Boolean,
            default: false
        },
        captcha: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        col: {
            type: Boolean,
            default: false
        },
        nomargin: {
            type: Boolean,
            default: false
        }
    }
    // data () {
    // },
    // methods: {
    // }
}
</script>
